import { showSpreedlyAddCard } from "./actions/showSpreedlyAddCard";
import { SpreedlyAddCardForm } from "./components/SpreedlyAddCardForm";
import { AddCardBehavior } from "src/features/paymentGateways/types";

export const addCardBehavior: AddCardBehavior = {
    showAddCard: showSpreedlyAddCard,
    addCardFormElement: SpreedlyAddCardForm,
};
